export default __webpack_public_path__ + "static/feat-4795e7d031f176664babf08cd10889b6.png";